import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth.jsx";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Brand } from "@/components/shared/Common";

export default function RegisterDoctor() {
  const [f, setF] = useState({
    first_name: "", last_name: "", email: "", mobile: "", dob: "",
    professional_location: "United Kingdom", registration_body: "GMC",
    registration_number: "", specialty: "general_practice", qualifications: "",
    years_experience: 0, bio: "", languages: "English", password: "", consent: false,
  });
  const [specialties, setSpecialties] = useState([]);
  const [loading, setLoading] = useState(false);
  const { registerDoctor } = useAuth();
  const nav = useNavigate();

  useEffect(() => { api.get("/specialties").then(r => setSpecialties(r.data)); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.consent) return toast.error("Please accept the consent notice.");
    setLoading(true);
    try {
      await registerDoctor({ ...f, years_experience: Number(f.years_experience)||0, languages: f.languages.split(",").map(s => s.trim()).filter(Boolean) });
      toast.success("Application submitted. We'll review your credentials shortly.");
      nav("/doctor/verification");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="cm-container py-14 flex justify-center">
      <div className="w-full max-w-2xl">
        <div className="text-center mb-8">
          <Link to="/"><Brand /></Link>
          <h1 className="cm-h3 mt-4">Join CAREMatch as a doctor</h1>
          <p className="text-sm text-[#475569] mt-2">Your application will enter our verification queue.</p>
        </div>
        <form className="cm-card grid sm:grid-cols-2 gap-4" onSubmit={submit} data-testid="register-doctor-form">
          <div><label className="cm-label">First name</label><input className="cm-input" required value={f.first_name} onChange={set("first_name")} data-testid="dr-first-name"/></div>
          <div><label className="cm-label">Last name</label><input className="cm-input" required value={f.last_name} onChange={set("last_name")} data-testid="dr-last-name"/></div>
          <div className="sm:col-span-2"><label className="cm-label">Email</label><input className="cm-input" type="email" required value={f.email} onChange={set("email")} data-testid="dr-email"/></div>
          <div><label className="cm-label">Mobile</label><input className="cm-input" value={f.mobile} onChange={set("mobile")} data-testid="dr-mobile"/></div>
          <div><label className="cm-label">Date of birth</label><input className="cm-input" type="date" value={f.dob} onChange={set("dob")} data-testid="dr-dob"/></div>
          <div><label className="cm-label">Professional location</label><input className="cm-input" value={f.professional_location} onChange={set("professional_location")} data-testid="dr-location"/></div>
          <div><label className="cm-label">Registration body</label><input className="cm-input" value={f.registration_body} onChange={set("registration_body")} data-testid="dr-reg-body"/></div>
          <div><label className="cm-label">Registration number (e.g. GMC)</label><input className="cm-input" value={f.registration_number} onChange={set("registration_number")} data-testid="dr-reg-num"/></div>
          <div><label className="cm-label">Specialty</label>
            <select className="cm-input" value={f.specialty} onChange={set("specialty")} data-testid="dr-specialty">
              {specialties.map(s => <option key={s.key} value={s.key}>{s.name}</option>)}
            </select>
          </div>
          <div className="sm:col-span-2"><label className="cm-label">Qualifications</label><input className="cm-input" value={f.qualifications} onChange={set("qualifications")} placeholder="MBBS, MRCP…" data-testid="dr-quals"/></div>
          <div><label className="cm-label">Years of experience</label><input className="cm-input" type="number" min="0" value={f.years_experience} onChange={set("years_experience")} data-testid="dr-years"/></div>
          <div><label className="cm-label">Languages (comma-separated)</label><input className="cm-input" value={f.languages} onChange={set("languages")} data-testid="dr-langs"/></div>
          <div className="sm:col-span-2"><label className="cm-label">Bio</label><textarea className="cm-input min-h-[100px]" value={f.bio} onChange={set("bio")} data-testid="dr-bio"/></div>
          <div className="sm:col-span-2"><label className="cm-label">Password</label><input className="cm-input" type="password" required minLength={8} value={f.password} onChange={set("password")} data-testid="dr-password"/></div>
          <label className="sm:col-span-2 flex items-start gap-2 text-sm text-[#475569]">
            <input type="checkbox" checked={f.consent} onChange={set("consent")} data-testid="dr-consent" className="mt-1"/>
            I confirm my details are accurate and I agree to CAREMatch's <Link to="/legal/doctor-terms" className="text-[#4a90d9] font-semibold">Doctor Terms</Link>.
          </label>
          <button className="cm-btn-primary sm:col-span-2 w-full" disabled={loading} data-testid="dr-submit">{loading?"Submitting…":"Submit application"}</button>
        </form>
      </div>
    </div>
  );
}
